import PropTypes from 'prop-types';

export const apolloClientType = PropTypes.shape({
  query: PropTypes.func.isRequired,
  mutate: PropTypes.func.isRequired,
});
